export default "__VITE_ASSET__Cglqrai___"